import './initialization';
import { init as initWatchers, stop as stopWatchers } from './watcher';

initWatchers();

// eslint-disable-next-line import/prefer-default-export
export function destroy() {
  stopWatchers();
}



// WEBPACK FOOTER //
// ./src/firebase/index.js